import { useEffect } from 'react';
import { Box, Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PencilOutlineIcon } from 'Asset/icon';
import Badge from 'UiKit/badge';
import ButtonOutline from 'UiKit/button/buttonOutline';
import { TextRegular, TextSemiBold } from 'UiKit/typography';
import { Condition } from 'Component/others';

import getBadgeVariant from 'View/host/helper/getBadgeVariant';
import FieldDescription from 'View/host/component/field-description';
import FieldAccount from 'View/host/component/field-account';

import styles from './styles.module.css';

const ScheduleCard = ({ data, isExpand, onChangeExpandedCard, isDefaultExpand }) => {
  const { t } = useTranslation('host-schedule');
  const navigate = useNavigate();
  const badgeVariant = getBadgeVariant(data?.achievementStatus);
  const isExpandCard = isExpand ? [0] : [undefined];

  const onChangeAccordion = (index) => {
    if (index === 0) onChangeExpandedCard?.(data?.id);
    else onChangeExpandedCard?.();
  };

  useEffect(() => {
    if (isDefaultExpand) onChangeExpandedCard(data?.id);
    /* eslint-disable */
  }, []);

  return (
    <Box className={styles['schedule-card__container']}>
      <Accordion index={isExpandCard} allowToggle onChange={onChangeAccordion}>
        <AccordionItem border="none">
          <AccordionButton className={styles['head__section']}>
            <Box className={styles['head__info']}>
              <TextSemiBold className={styles['title']}>{data?.title}</TextSemiBold>
              <Condition statement={data?.achievementStatus}>
                <Badge variant={badgeVariant} size="sm" className={styles['badge']}>
                  <Condition statement={data?.achievementStatus === 'Achievement Tersedia'}>{t('achievement_status.available')}</Condition>
                  <Condition statement={data?.achievementStatus === 'Achievement Belum Tersedia'}>{t('achievement_status.not_available')}</Condition>
                </Badge>
              </Condition>
              <TextRegular className={styles['date__text']}>{data?.datetime}</TextRegular>
            </Box>

            <AccordionIcon boxSize={'20px'} color="var(--color-semantic-text)" className={styles['accordion__icon']} />
          </AccordionButton>

          <AccordionPanel className={styles['content__section']}>
            <FieldAccount data={data?.account} />
            <FieldDescription label={t('card.host')} value={data?.host} />
            <FieldDescription label={t('card.room_studio_name')} value={data?.room} />
            <FieldDescription label={t('card.operator')} value={data?.operator} />

            <Box className={styles['content__section-button-container']}>
              <Condition statement={data?.isCanRequestReschedule && data?.reschedule?.statusProgress !== 'Diproses'}>
                <ButtonOutline
                  height="34px"
                  onClick={() => navigate(`/reschedule-form/${data?.id}`)}
                  className={styles['button-change-schedule']}
                  borderWidth="1.5px"
                >
                  <PencilOutlineIcon size={18} color="var(--color-primary70)" />
                  <TextSemiBold className={styles['button__text']}>{t('action.change_schedule')}</TextSemiBold>
                </ButtonOutline>
              </Condition>
              <ButtonOutline
                height="34px"
                borderWidth="1.5px"
                onClick={() => navigate(`/host/detail/${data?.id}`)}
                className={styles['button-detail-schedule']}
              >
                <TextSemiBold className={styles['button__text']}>{t('action.view_detail')}</TextSemiBold>
              </ButtonOutline>
            </Box>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Box>
  );
};

export default ScheduleCard;
